import InjectTranslation from '../inject-translation';
import React, { Component } from 'react';
import { Button, Modal, NackleIllustration, Typography } from '@nackle/origami';
import { LocaleString } from '@nackle/intl-tools';

const { ArcadeWinner } = NackleIllustration;
const { Title, Text } = Typography;

const getAmount = ( value ) => {
  const num = Number( value );
  if ( isNaN( num ) ) {return 0;}
  return num;
};


export class AwardDialog extends Component {
  state = {
    isLoading: false,
  };

  render() {
    const { rewards, onPlayAgain, open, onClose } = this.props;

    const rewardAmount = rewards.reduce(
      ( memo, reward ) => memo + getAmount( reward.value ),
      0
    );
    return (
      <>
        { open && (
          <InjectTranslation
            params={ {
              [ 'game.loader.CLOSE' ]: null,
              [ 'game.loader.PLAY.AGAIN' ]: null,
              [ 'game.loader.YOU.WON' ]: null,
              [ 'mediaLabel' ]: null,
              [ 'game.loader.MESSAGE' ]: { amount: rewardAmount },
            } }
          >
            { ( {
              'game.loader.CLOSE': closeText,
              'game.loader.PLAY.AGAIN': playAgainText,
              'game.loader.YOU.WON': youWonText,
              'mediaLabel': pointsText,
              [ 'game.loader.MESSAGE' ]: message,
            } ) => (
              <Modal
                title={ youWonText }
                className='winner-section'
                getContainer=".game-container"
                maskClosable={ false }
                keyboard={ false }
                closable
                onCancel={ onClose }
                open={ open }
                centered
                footer={ [
                <Button
                  key="close"
                  onClick={ onClose }
                  style={ !onPlayAgain ? { marginLeft: 'auto' } : undefined }
                >
                  { /* {closeText} */ }
                  <LocaleString code="game.loader.CLOSE" />
                </Button>,

                onPlayAgain && (
                  <Button
                    key="play"
                    type="primary"
                    loading={ this.state.isLoading }
                    onClick={ this.handleClickPlayAgain }
                    style={ { marginLeft: 'auto' } }
                  >
                    <LocaleString code="game.loader.PLAY.AGAIN" />
                  </Button>
                ),
              ] }
              >
                { /* Illustration */ }
                <div style={ { textAlign: 'center' } }>
                  <ArcadeWinner aria-label="winner" width={ 260 } height={ 260 } />
                </div>

                { /* Title */ }
                <Title level={ 2 } style={ { textAlign: 'center' } } strong>
                  { rewardAmount } <LocaleString code="mediaLabel" />!
                </Title>

                { /* Subtitle */ }
                <Text type="secondary" style={ { display: 'block', textAlign: 'center' } } >
                  <LocaleString code="game.loader.MESSAGE" />
                </Text>
              </Modal>
            ) }
          </InjectTranslation>
        ) }
      </>
    );
  }

  handleClickPlayAgain = async () => {
    this.setState( { isLoading: true } );
    try {
      const { onPlayAgain } = this.props;
      if ( onPlayAgain ) {
        await onPlayAgain();
      }
    } finally {
      this.setState( { isLoading: false } );
    }
  };
}